// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 594 ? "about" : chunkId) + "." + {"353":"0013f5e4","427":"823af5b4","594":"2fc8e506"}[chunkId] + ".js";
};